// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

// models
import { UserSettings } from '@/vue3/api/models';

export const useUserSettingService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive
    const userSettings = ref<UserSettings[]>([]);

    // methods
    const getUserSettings = async (): Promise<UserSettings> => {
        const res = await axios.get(`${apiUrl}/user-settings`);
        userSettings.value = res.data;
        return res.data;
    };

    const createUserSettings = async (
        UserSettings: UserSettings,
    ): Promise<UserSettings> => {
        const res = await axios.post(`${apiUrl}/user-settings`, UserSettings);
        return res.data;
    };

    const updateUserSettings = async (
        UserSettings: UserSettings,
    ): Promise<UserSettings> => {
        const res = await axios.put(`${apiUrl}/user-settings`, UserSettings);
        return res.data;
    };

    return {
        getUserSettings,
        createUserSettings,
        updateUserSettings,
        userSettings,
    };
};
